const POST_MODERATION_ADMIN_PHONE = "9614968401";

export function canAccessPostModeration(user?: {
  emailOrPhone?: string;
  isSupportAgent?: boolean;
} | null) {
  const phone = (user?.emailOrPhone ?? "").replace(/\D/g, "").slice(-10);
  return Boolean(user?.isSupportAgent && phone === POST_MODERATION_ADMIN_PHONE);
}
